import { Component } from '@angular/core';

@Component({
  selector: 'app-dispute-resolution',
  standalone: false,
  templateUrl: './dispute-resolution.component.html',
  styleUrl: './dispute-resolution.component.scss'
})
export class DisputeResolutionComponent {

}
